import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faHome,
  faSearch,
  faColumns,
  faAddressCard,
  faSignInAlt,
  faUserPlus,
  faComments,
  faEnvelope,
  faAngleDown,
  faAngleUp,
  faPlayCircle,
  faStar,
  faMinusCircle,
  faCheck,
  faPlus,
  faEye,
  faRandom,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(
  faUser,
  faHome,
  faSearch,
  faColumns,
  faAddressCard,
  faSignInAlt,
  faUserPlus,
  faComments,
  faEnvelope,
  faAngleDown,
  faAngleUp,
  faPlayCircle,
  faStar,
  faMinusCircle,
  faCheck,
  faPlus,
  faEye,
  faRandom,
);

export { FontAwesomeIcon };
